export default {
  namespaced: true,

  state: {
    customerName: null,
    classroomName: null,
    accessToken: null,
    client: null,
    id: null,
    uid: null,
    role: null,
    hasLogo: false,
    lastOperatedDate: null,
  },

  getters: {
    isAdmin: state => {
      return state.role === 'Admin'
    },
    isTeacher: state => {
      return state.role === 'Teacher'
    },
    isSampleAccount: state => {
      return state.uid === '0'
    },
    isEnrollment: state => {
      return state.role === 'enrollment'
    },
    homePath: (state, getters) => {
      // /admin/home or /teacher/home or /enrollment
      if (getters.isEnrollment) return '/enrollment'
      return '/'+state.role.toLowerCase()+'/home'
    },
    signInPath: (state, getters) => {
      if (getters.isAdmin) return '/admin/sign_in'
      else return '/sign_in'
    }
  },

  mutations: {
    setRole(state, payload) {
      state.role = payload.role;
    },

    setLastOperatedDate(state, payload) {
      state.lastOperatedDate = payload.lastOperatedDate;
    },

    setClassroomName(state, payload) {
      state.classroomName = payload.name
    },

    login(state, payload) {
      state.accessToken = payload.accessToken;
      state.client = payload.client;
      state.uid = payload.uid;
      state.id = payload.id;
      state.customerName = payload.customerName;
      state.classroomName = payload.branchName;
      state.hasLogo = payload.hasLogo
    },

    logout(state) {
      state.accessToken = null
      state.client = null
      state.uid = null
      state.id = null
      state.customerName = null
      state.classroomName = null
      state.hasLogo = false
    },
  },
}
